// Utility functions for handling mathematical expressions

/**
 * Strips MathJax delimiters from a string for comparison purposes
 * Converts "$$e^x$$" to "e^x"
 */
export function stripMathDelimiters(text: string): string {
  if (!text) return '';
  return text.replace(/\$\$/g, '').trim();
}

/**
 * Normalizes an answer for comparison
 * - Strips MathJax delimiters
 * - Converts to lowercase
 * - Trims whitespace
 * - Normalizes common mathematical expressions
 */
export function normalizeAnswer(answer: string): string {
  if (!answer) return '';
  
  let normalized = stripMathDelimiters(answer);
  normalized = normalized.toLowerCase().trim();
  
  // Normalize common variations
  normalized = normalized.replace(/\s+/g, ''); // Remove all whitespace
  normalized = normalized.replace(/\\text\{([^}]+)\}/g, '$1'); // Remove \text{} wrapper
  
  return normalized;
}

/**
 * Compares two answers for equality, accounting for MathJax formatting
 */
export function answersMatch(studentAnswer: string, correctAnswer: string): boolean {
  return normalizeAnswer(studentAnswer) === normalizeAnswer(correctAnswer);
}
